import { useMutation } from "@shared/lib/hooks";
import { ToastService } from "@shared/lib/services";
import { InfluencerService } from "../services/influencer.service";
import { BackednResponse } from "@shared/lib/types";
import { INFLUENCER_LIST_QUERY_KEY } from "../constants";
import { DOWNLOADS_LIST_QUERY_KEY } from "@entities/downloads/lib/constant";

export function useBulkUploadInfluencers() {
  const {
    mutate: update,
    isLoading: isUpdating,
    isSuccess: isUpdated,
  } = useMutation<
    { inputFileUrl: string; bucketId?: string },
    BackednResponse<{}> | void
  >({
    mutationFn: async ({ inputFileUrl, bucketId }) => {
      return await InfluencerService.bulkUploadInfluencers(
        inputFileUrl,
        bucketId
      ).catch(async (err) => {
        const responseBody = await err.response.json();
        ToastService.error(responseBody.msg);
        throw err;
      });
    },
    options: {
      queryKey: INFLUENCER_LIST_QUERY_KEY,
      skipInvalidation: false,
    },
    onSuccess: (c, data) => {
      c.invalidateQueries({ queryKey: [DOWNLOADS_LIST_QUERY_KEY] });
    },
  });

  return {
    update,
    isUpdating,
    isUpdated,
  };
}
